import { EntityState } from "@ngrx/entity";

import { LikeEntity } from '../entities';

export interface LikeState extends EntityState<LikeEntity> {
    isLoading: boolean,
    isLoaded: boolean
}